import { useTranslation } from 'react-i18next';
import type { TaskStatus } from '@monorepo/shared';
import { taskStatusDisplay } from './taskDisplay';

interface TaskStatusBadgeProps {
  status: TaskStatus;
}

export const TaskStatusBadge = ({ status }: TaskStatusBadgeProps) => {
  const { t } = useTranslation();
  const display = taskStatusDisplay[status];

  return (
    <span
      className={`inline-flex items-center gap-2 whitespace-nowrap text-sm ${display.textClassName}`}
    >
      <span className={`w-2 h-2 rounded-full ${display.dotClassName}`} />
      {t(display.label)}
    </span>
  );
};
